/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online Timer`)
};

const es_timer_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador Online`)
};

const de_timer_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online-Timer`)
};

const nl_timer_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online Timer`)
};

const fr_timer_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuteur en ligne`)
};

const it_timer_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer Online`)
};

const pt_br2_timer_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador Online`)
};

const pt_timer_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador Online`)
};

const ja_timer_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オンラインタイマー`)
};

const zh_timer_hub_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线计时器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_hub_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_hub_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_hub_h1", locale)
	if (locale === "en") return en_timer_hub_h1(inputs)
	if (locale === "es") return es_timer_hub_h1(inputs)
	if (locale === "de") return de_timer_hub_h1(inputs)
	if (locale === "nl") return nl_timer_hub_h1(inputs)
	if (locale === "fr") return fr_timer_hub_h1(inputs)
	if (locale === "it") return it_timer_hub_h1(inputs)
	if (locale === "pt-BR") return pt_br2_timer_hub_h1(inputs)
	if (locale === "pt") return pt_timer_hub_h1(inputs)
	if (locale === "ja") return ja_timer_hub_h1(inputs)
	return zh_timer_hub_h1(inputs)
};